<template>
  <div
    class="transfer"
    style="overflow-y: hidden; height: 100%; background-color: #fff"
  >
    <div class="tran_top">
      <label>面向作者的概括式授权书：</label>
    </div>
    <div class="tran_middle" align="center">
      <a-textarea id="textarea" v-model="transferAgreement"></a-textarea>
      <div style="width: 200px; float: left">
        <a-upload
          name="file"
          :fileList="fileList"
          :action="serviceAddress"
          :headers="headers"
          @change="uploadFile"
          :remove="fileRemove"
          :data="data"
          accept=".pdf"
        >
          <a-button type="primary" style="margin-top: 10px">
            上传授权书</a-button
          >
        </a-upload>
      </div>
      <div style="clear: both"></div>
      <a-button type="primary" @click="submit" style="margin-top: 10px">
        保存
      </a-button>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "transferAgreement",
  data() {
    return {
      serviceAddress: this.$config.serviceAddress + "/file/upload",
      headers: {
        authorization: "authorization-text",
      },
      data: {
        fileType: "manuscripts",
      },
      transferAgreement: "",
      transferFile: "",
      fileList: [],
    };
  },
  created() {
    this.query();
  },
  methods: {
    query() {
      this.axios
        .get("/manuscriptTemplate/queryTransferAgreement", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.transferAgreement = res.data.data.transferAgreement;
            this.transferFile = res.data.data.transferFile;
            if (this.transferFile) {
              this.fileList = [];
              this.fileList.push({
                uid: "-1",
                name: "授权书.pdf",
                status: "done",
                url: this.transferFile,
              });
            }
          } else {
            this.utils.messageInfo(this, "error", "查询转让协议失败！");
          }
        });
    },
    submit() {
      this.axios
        .post("/manuscriptTemplate/saveTransferAgreement", {
          transferAgreement: this.transferAgreement,
          transferFile: this.transferFile,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "保存成功！");
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "保存失败！");
          }
        });
    },
    uploadFile(info) {
      this.fileList = [];
      if (info.fileList.length == 2) {
        info.fileList.splice(0, 1);
      }
      let fileList = [...info.fileList];
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.data.filePath;
        }
        return file;
      });
      this.fileList = fileList;
      if (info.file.status !== "uploading") {
        this.fileList = info.fileList;
      }
      if (info.file.status === "done") {
        this.transferFile = info.file.response.data.filePath;
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    fileRemove(file) {
      this.fileList = [];
      var data = file.response;
      if (data.code == "OK") {
        this.axios.post("/file/deleteFile", {
          url: data.data.realFilePath,
        });
      }
    },
  },
};
</script>

<style scoped>
.transfer .top {
  width: 100%;
  height: 15%;
}
#textarea {
  width: 100%;
  height: 450px;
  margin-top: 10px;
}
.middle #btn {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>